export const styles = {
  container: {
    marginBottom: "40px",
    "@media (max-width: 600px)": {
      margin: "0px 0px 20px",
    },
  },
  helpText: {
    marginBottom: "10px",
  },
};
